import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import { useAuth } from "../../context/AuthContext";
import ActiveSessionsModal from "../../components/common/ActiveSessionsModal";
import Profile from "../../assets/images/comman/user.svg";
import OPDIDPrint from "../../assets/images/OPD-patients/print.svg";

const Layout = ({ children }) => {
  const [showSessionsModal, setShowSessionsModal] = useState(false);
  const { user: currentUser } = useAuth();
  const location = useLocation();

  const displayName =
    currentUser?.name ||
    [
      currentUser?.firstName || currentUser?.f_name,
      currentUser?.lastName || currentUser?.l_name,
    ]
      .filter(Boolean)
      .join(" ") ||
    currentUser?.username ||
    currentUser?.email ||
    "";
  const displayRole = currentUser?.role_name || currentUser?.role || "";

  const pageTitles = {
    "/dashboard": "Dashboard",
    "/patients-list": "Patients",
    "/create-lab-report": "Lab Report",
    "/Patients": "OPD",
    "/doctor-diagnostics": "Diagnostics",
    "/consents": "Consents",
    "/listing": "ABHA Listing",
    "/add-patient": "Add Patient",
    "/OPDDetails": "OPD Details",
    "/billing": "Billing",
    "/select-patient-billing": "Billing",
    "/opd-assessment": "OPD Assessment",
    "/change-password": "Change Password",
    // Add all your routes here
  };

  const currentTitle =
    pageTitles[location.pathname] ||
    (location.pathname.startsWith("/patient-detail/")
      ? "Patient Details"
      : location.pathname.startsWith("/visit-summary/")
        ? "Visit Summary"
        : "Dashboard");

  return (
    <div className="main-page">
      <header className="app-header sticky" id="header">
        <div className="main-header-container container-fluid">
          <div className="header-content-left">
            <div className="pageName">
              <h4>{currentTitle}</h4>
            </div>
          </div>
          <div className="header-content-right">
            <ul className="header-content-right">
              <li>
                <div className="userName">
                  <h4>{displayName}</h4>
                  <p>{displayRole}</p>
                </div>
              </li>
              <li className="header-element dropdown">
                <button
                  className="header-link border-0 bg-transparent p-0"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={Profile}
                      className="userProfile"
                      alt="User Profile"
                    />
                  </div>
                </button>
                <ul className="main-header-dropdown dropdown-menu py-2 overflow-hidden header-profile-dropdown dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item d-flex align-items-center gap-2"
                      to="/change-password"
                    >
                      <i
                        className="material-icons"
                        style={{ fontSize: "18px", color: "#1429BB" }}
                      >
                        lock_reset
                      </i>
                      Change Password
                    </Link>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => setShowSessionsModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className="material-icons"
                        style={{ fontSize: "18px", color: "#1429BB" }}
                      >
                        devices
                      </i>
                      Active Sessions
                    </button>
                  </li>
                  {/* <li><hr className="dropdown-divider my-1" /></li>
                                    <li><a className="dropdown-item" href="/"><img src={OPDIDPrint} alt="OPD ID Print" /> OPD ID Print</a></li> */}
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </header>

      <Sidebar />
      <div className="main-content app-content">{children}</div>

      <ActiveSessionsModal
        isOpen={showSessionsModal}
        onClose={() => setShowSessionsModal(false)}
      />
    </div>
  );
};

export default Layout;
